// extracted by mini-css-extract-plugin
module.exports = {"invalid":"CurrencyInput_invalid__2Yv-Z"};